import { homeMock } from "./homeMock";
import { aboutMock } from "./aboutMock";
import { contactMock } from "./contactMock";
import { privacyPolicyMock } from "./privacyPolicyMock";
import { termsConditionsMock } from "./termsConditionsMock";
import { faqMock } from "./faqMock";
import { accountsMock } from "./accountsMock";
import { whyUsMock } from "./whyUsMock";
import { feesChargesMock } from "./feesChargesMock";
import { affiliatesMock } from "./affiliatesMock";
import { tradingMock } from "./tradingMock";
import { depositsWithdrawalsMock } from "./depositsWithdrawalsMock";
import { whatIsForexTradingMock } from "./whatIsForexTradingMock";
import { whatIsCryptocurrencyTradingMock } from "./whatIsCryptocurrencyTradingMock";
import { whatIsCfdTradingMock } from "./whatIsCfdTradingMock";
import { cfdTradingMock } from "./cfdTradingMock";
import { tradingPlatformsMock } from "./tradingPlatformsMock";
import { cryptocurrencyTradingMock } from "./cryptocurrencyTradingMock";
import { riskDisclosureMock } from "./riskDisclosureMock";

export const MOCK_PAGES = {
  // home: homeMock,
  // "about-us": aboutMock,
  // "contact-us": contactMock,
  // "privacy-policy": privacyPolicyMock,
  // "terms-and-conditions": termsConditionsMock,
  // faq: faqMock,
  // accounts: accountsMock,
  // "why-us": whyUsMock,
  // "fees-and-charges": feesChargesMock,
  // affiliates: affiliatesMock,
  // trading: tradingMock,
  // "deposits-and-withdrawals": depositsWithdrawalsMock,
  // "what-is-forex-trading": whatIsForexTradingMock,
  // "what-is-cryptocurrency-trading": whatIsCryptocurrencyTradingMock,
  // "what-is-cfd-trading": whatIsCfdTradingMock,
  // "cfd-trading": cfdTradingMock,
  // "trading-platforms": tradingPlatformsMock,
  // "cryptocurrency-trading": cryptocurrencyTradingMock,
  // "risk-disclosure": riskDisclosureMock,
};
